import { Button, ButtonGroup, Modal } from 'slab'
import { type PayrollProviderConfig } from 'utils/web_api.schemas'
export function SharedConnectionConfirmationModal ({
  open,
  onOpenChange,
  onConfirm,
  providerConfig,
  isLoading = false
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  providerConfig: PayrollProviderConfig
  isLoading?: boolean
}) {
  const handleConfirm = () => {
    onConfirm()
  }

  const handleClose = () => {
    if (!isLoading) {
      onOpenChange(false)
    }
  }

  return (
    <Modal
      open={open}
      onOpenChange={handleClose}
    >
      <Modal.Body>
        <Modal.Title size='large' dismissible={false}>
          <img
            aria-hidden // The image is decorative and not necessary for screen readers
            src={providerConfig.icon_image_url}
            className='w-8 h-8 rounded-full border border-gray-200 mr-4 mb-1 inline'
          />
          Connect to {providerConfig.name}
        </Modal.Title>
        <Modal.Description>
          <div className='flex flex-col gap-4'>
            <p>
              Connecting to {providerConfig.name} will allow Thatch to automatically sync your employee roster.
            </p>
            <p>
              Thatch will work with {providerConfig.name} directly to finish setting up your connection.
              Your first roster sync will occur within 24 hours of completing your account setup.
            </p>
          </div>
        </Modal.Description>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup align='right'>
          <Button
            variant='secondary'
            size='large'
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Modal.Button
            variant='primary'
            size='large'
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Connecting...' : 'Connect'}
          </Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
